import { Logo } from 'shared/ui/logo';
import styles from './styles.module.scss';

type Scene = 'workstation' | 'laptop';

interface BrandedBackgroundProps {
    scene: Scene;
    className?: string;
    loading?: 'eager' | 'lazy';
}

export const BrandedBackground = ({ scene, className = '', loading = 'lazy' }: BrandedBackgroundProps) => {
    const base = `/images/ansar-${scene}-v2`;
    const sources = (format: string) => [640, 960, 1600].map(width => `${base}-${width}.${format} ${width}w`).join(', ');
    const sizes = scene === 'workstation'
        ? '(max-width: 760px) 100vw, (min-width: 1400px) 960px, 780px'
        : '(max-width: 760px) 100vw, 520px';

    return (
        <div className={`${styles.background} ${className}`} aria-hidden="true">
            <div className={`${styles.frame} ${styles[scene]}`}>
                <picture className={styles.picture}>
                    <source type="image/avif" srcSet={sources('avif')} sizes={sizes} />
                    <img src={`${base}-960.webp`} srcSet={sources('webp')} sizes={sizes} width="1600" height="800" alt="" loading={loading} decoding="async" />
                </picture>
                <div className={styles.screenMark}><Logo cropToMark /></div>
            </div>
        </div>
    );
};
